__turbopack_context__.v({
  "container": "SyncedPanes-module__mmTwja__container",
  "input": "SyncedPanes-module__mmTwja__input",
  "label": "SyncedPanes-module__mmTwja__label",
  "pane": "SyncedPanes-module__mmTwja__pane",
});
